(function(){
  if(window.__zmg)return;window.__zmg=1;
  var tries=0;
  function boot(){
    var g=document.querySelector('media-gallery');
    if(!g||!g.slider||typeof g.slider!=='object'||!g.navSlider){
      if(++tries<40)return setTimeout(boot,150);
      return;
    }
    var main=g.slider,nav=g.navSlider;
    try{main.params.speed=450;}catch(e){}
    function idx(){return typeof main.realIndex==='number'?main.realIndex:main.activeIndex;}
    function follow(){
      var i=idx();
      var slides=nav.slides||[];
      var el=slides[i];
      if(!el)return;
      var vertical=nav.params&&nav.params.direction==='vertical';
      var size=vertical?nav.height:nav.width;
      var pos=vertical?el.offsetTop:el.offsetLeft;
      var len=vertical?el.offsetHeight:el.offsetWidth;
      var max=-nav.maxTranslate();
      var target=Math.max(0,Math.min(max,pos-(size-len)/2));
      nav.setTransition(450);
      nav.setTranslate(-target);
      nav.updateProgress&&nav.updateProgress(-target);
      nav.updateSlidesClasses&&nav.updateSlidesClasses();
      slides.forEach(function(s,k){s.classList.toggle('zmg-on',k===i);});
    }
    main.on('slideChange',follow);
    main.on('transitionEnd',follow);
    follow();
    var canHover=window.matchMedia&&window.matchMedia('(hover:hover) and (pointer:fine)').matches;
    var timer;
    (nav.slides||[]).forEach(function(s,k){
      if(canHover){
        s.addEventListener('mouseenter',function(){
          clearTimeout(timer);
          timer=setTimeout(function(){
            if(idx()!==k){try{main.slideToLoop(k,450);}catch(e){main.slideTo(k,450);}}
          },60);
        });
        s.addEventListener('mouseleave',function(){clearTimeout(timer);});
      }
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();